import { render, staticRenderFns } from "./CertificatStep1.vue?vue&type=template&id=4122a699&scoped=true&"
import script from "./CertificatStep1.vue?vue&type=script&lang=js&"
export * from "./CertificatStep1.vue?vue&type=script&lang=js&"
import style0 from "./CertificatStep1.vue?vue&type=style&index=0&id=4122a699&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4122a699",
  null
  
)

export default component.exports